// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"77":"a4ae9bda","766":"df38995d","817":"190b7df9"}[chunkId] + ".chunk.css";
};